import { io, type Socket } from 'socket.io-client';
import { env } from '@/config';
import { logger } from './logger';

let socket: Socket | null = null;

export function connectWebSocket(token: string): Socket {
  if (socket?.connected) {
    return socket;
  }

  socket = io(env.wsUrl, {
    auth: { token },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionAttempts: 10,
  });

  socket.on('connect', () => {
    logger.info('WebSocket povezan');
    for (const episodeId of roomCounts.keys()) {
      socket?.emit('join:episode', { episodeId });
    }
  });

  socket.on('disconnect', (reason) => {
    logger.warn('WebSocket diskonektovan', reason);
  });

  socket.on('connect_error', (error) => {
    logger.error('WebSocket greska', error);
  });

  return socket;
}

export function disconnectWebSocket(): void {
  roomCounts.clear();
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}

export function getSocket(): Socket | null {
  return socket;
}

// Rooms are counted, not just joined: the episode page and its TIM tab both
// subscribe to the same episode, and the tab unmounting must not take the page
// out of the room. A reconnect starts with no rooms on the server, so the
// joined ones are re-sent on every connect.
const roomCounts = new Map<string, number>();

export function joinEpisodeRoom(episodeId: string): void {
  const count = roomCounts.get(episodeId) ?? 0;
  roomCounts.set(episodeId, count + 1);
  if (count === 0) socket?.emit('join:episode', { episodeId });
}

export function leaveEpisodeRoom(episodeId: string): void {
  const count = roomCounts.get(episodeId) ?? 0;
  if (count > 1) {
    roomCounts.set(episodeId, count - 1);
    return;
  }
  roomCounts.delete(episodeId);
  socket?.emit('leave:episode', { episodeId });
}
